import React from 'react';
import { Badge, getInvoiceStatusVariant, getSubscriptionStatusVariant, getPaymentStatusVariant } from '../ui/Badge';
import { InvoiceStatus, SubscriptionStatus, PaymentStatus } from '../../types';
interface InvoiceStatusBadgeProps {
  status: InvoiceStatus;
}
export function InvoiceStatusBadge({
  status
}: InvoiceStatusBadgeProps) {
  return <Badge variant={getInvoiceStatusVariant(status)} data-id="element-92">
      {status.charAt(0).toUpperCase() + status.slice(1)}
    </Badge>;
}
interface SubscriptionStatusBadgeProps {
  status: SubscriptionStatus;
}
export function SubscriptionStatusBadge({
  status
}: SubscriptionStatusBadgeProps) {
  return <Badge variant={getSubscriptionStatusVariant(status)} data-id="element-93">
      {status.charAt(0).toUpperCase() + status.slice(1)}
    </Badge>;
}
interface PaymentStatusBadgeProps {
  status: PaymentStatus;
}
export function PaymentStatusBadge({
  status
}: PaymentStatusBadgeProps) {
  return <Badge variant={getPaymentStatusVariant(status)} data-id="element-94">
      {status.charAt(0).toUpperCase() + status.slice(1)}
    </Badge>;
}